import { Component, Inject } from '@angular/core';
import { MatDialogContent, MatDialogClose, MatDialogActions, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInterventionDbInterface } from '../../interfaces/intervention-db-interface';
import { KeyValuePipe } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-intervention-card',
    standalone: true,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        KeyValuePipe, 
        ScrollingModule
    ],
    templateUrl: './intervention-card.component.html',
    styleUrl: './intervention-card.component.scss'
})
export class InterventionCardComponent {
    constructor(
        public dialogRef: MatDialogRef<InterventionCardComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IInterventionDbInterface,
    ) { }
}
